import { commonService } from '.';

const getBusinessManager = () => {
    return commonService.getWithParam('BusinessManager', null);
};

const getSkillBusinessManager = (idBusinessManager, idLang) => {
    return commonService.getWithParam('BusinessManager/skillBusinessManager?idBusinessManager=' + idBusinessManager + '&idLang=' + idLang, null);
}

const getNewEepBM = (request) => {
    let idUser = request.idUser;
    let year = request.year;
    let idLang = request.idLang;
    return commonService.getWithParam('Ea/newEepBm?idUser=' + idUser + '&year=' + year + '&idLang=' + idLang, null);
}

const getEepBmDetails = (request) => {
    let idUser = request.idUser;
    let year = request.year;
    let idLang = request.idLang;
    return commonService.getWithParam('Ea/eepBmDetails?idUser=' + idUser + '&year=' + year + '&idLang=' + idLang, null);
}

const checkEEPData = (idUser, year, isUserHimSelf) => {
    return commonService.getWithParam('BusinessManager/checkEEPData?idUser=' + idUser + '&year=' + year + '&isUserHimSelf=' + isUserHimSelf, null);
}

const getGlobalSkillsSummary = (request) => {
    let idUser = request.idUser;
    let year = request.year;
    let idLang = request.idLang;
    let idBusinessManager = request.idBusinessManager;
    return commonService.getWithParam('SkillsEvaluation/globalSkillsSummary?idUser=' + idUser + '&year=' + year + '&idLang=' + idLang + '&idBusinessManager=' + idBusinessManager, null);
}

export const businessManagerService = {
    getBusinessManager,
    getSkillBusinessManager,
    getNewEepBM,
    getEepBmDetails,
    checkEEPData,
    getGlobalSkillsSummary
};
